import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

interface IconProps extends SvgIconProps {}

const LinikedShowHypothesesIcon = (props: IconProps) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M11 1C3.85714 1 1 7.42857 1 7.42857C1 7.42857 3.85714 13.8571 11 13.8571C18.1429 13.8571 21 7.42857 21 7.42857C21 7.42857 18.1429 1 11 1Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0001 11C12.9726 11 14.5716 9.40105 14.5716 7.42861C14.5716 5.45616 12.9726 3.85718 11.0001 3.85718C9.02769 3.85718 7.42871 5.45616 7.42871 7.42861C7.42871 9.40105 9.02769 11 11.0001 11Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default LinikedShowHypothesesIcon;
